import { ref } from 'vue';

const useOnRowIsDisabled = () => {
  const rowIsDisabled = ref(false);

  const onRowIsDisabled = (status) => {
    rowIsDisabled.value = status;
  };

  return {
    onRowIsDisabled,
  };
};

export default useOnRowIsDisabled;
